import type { PostType } from '@/mocks/adminPosts';
import { postTypeLabels, postTypeIcons } from '@/mocks/adminPosts';

interface CreatePostComposerProps {
  onCreatePost: (type?: PostType) => void;
}

const postTypes: PostType[] = ['texto', 'imagen', 'video', 'encuesta', 'patrocinada'];

const quickTypeColors: Record<PostType, string> = {
  texto: 'text-foreground-500 hover:bg-background-100',
  imagen: 'text-emerald-600 hover:bg-emerald-50',
  video: 'text-rose-600 hover:bg-rose-50',
  encuesta: 'text-amber-600 hover:bg-amber-50',
  patrocinada: 'text-primary-600 hover:bg-primary-50',
};

const quickTypeIconBg: Record<PostType, string> = {
  texto: 'bg-foreground-100',
  imagen: 'bg-emerald-100',
  video: 'bg-rose-100',
  encuesta: 'bg-amber-100',
  patrocinada: 'bg-primary-100',
};

export default function CreatePostComposer({ onCreatePost }: CreatePostComposerProps) {
  return (
    <div className="bg-background-50 rounded-xl border border-background-200 p-4">
      {/* Top: avatar + input trigger */}
      <div className="flex items-center gap-3 pb-3 border-b border-background-200">
        <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center shrink-0 overflow-hidden">
          <span className="text-primary-700 font-bold text-sm">RNA</span>
        </div>
        <button
          onClick={() => onCreatePost()}
          className="flex-1 text-left px-4 py-2.5 rounded-full bg-background-100 text-sm text-foreground-400 hover:bg-background-200 cursor-pointer transition-colors"
        >
          ¿Qué querés publicar, Radio Nueva Actitud?
        </button>
      </div>

      {/* Bottom: quick type buttons */}
      <div className="flex items-center gap-1 pt-3">
        {postTypes.map((type) => (
          <button
            key={type}
            onClick={() => onCreatePost(type)}
            className={`flex-1 flex items-center justify-center gap-1.5 py-2 rounded-lg text-[11px] font-semibold cursor-pointer transition-colors ${quickTypeColors[type]}`}
          >
            <span className={`w-6 h-6 rounded-full ${quickTypeIconBg[type]} flex items-center justify-center`}>
              <i className={`${postTypeIcons[type]} text-[11px]`}></i>
            </span>
            <span className="hidden sm:inline">{postTypeLabels[type]}</span>
          </button>
        ))}
      </div>
    </div>
  );
}